import { CustomEventWithDetail } from 'rune-ts';
import { FanLetterItemView } from '../FanLetterItemView';

export class FanLetterItemButtonHeartEvent extends CustomEventWithDetail<{
  is_like: boolean;
  fan_letter_id: number;
  store_id: number;
}> {}

export class FanLetterItemOpenDetailEvent extends CustomEventWithDetail<{
  fan_letter_id: number;
  element?: HTMLElement;
  fan_letter_item_view?: FanLetterItemView;
}> {}
